/* eslint-disable arrow-body-style */
import http from '@/utils/http';
import { handleRegionsCountriesData2Standard } from '@/pages/intelligence/utils/regionSelectUtils';
import type { IBaseResponse, IRegion } from '@/pages/intelligence/types/common';

export const getFilterListRegions: (payload: any) => Promise<any> = (payload) => {
  return http({
    url: '/api/v1/intelligence_pc/newFilterListRegionCountry',
    method: 'post',
    data: payload,
  }) as Promise<any>;
};

export const getCompaniesCommon: (payload: any) => Promise<any> = (payload) => {
  return http({
    // url: '/api/v1/intelligence_pc/getFilterCompanyList',
    url: '/api/v1/intelligence_pc/getFilterCompanyListByEntityType',
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
};

// 获取 Steam Tags、Game Mode 相关 tag 列表
export const getFilterTags: () => Promise<any> = () => {
  return http({
    url: 'api/v1/intelligence_pc/filterTags',
    method: 'post',
    // data: payload,
    rawData: true,
  }) as Promise<any>;
};

// 获取Steam Games，游戏筛选器游戏搜索接口
export const searchOverlapSteamGames: (payload: any) => Promise<any> = (payload) => {
  return http({
    url: '/api/v1/intelligence_pc/filterSteamOverlapGameList',
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
};

// 获取All Games，游戏筛选器游戏搜索通用接口
export const searchAllGames: (payload: any) => Promise<any> = (payload) => {
  return http({
    url: '/api/v1/intelligence_pc/filterTopChartsGameList',
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
};

// 搜索快捷接口
export const searchShortCutGames: (payload: any) => Promise<any> = (payload) => {
  return http({
    url: '/api/v1/homepage/pc/listCompetitorGameGenreType',
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
};

export const getNewReleaseCompanyList: (payload: any) => Promise<any> = (payload) => {
  return http({
    url: '/api/v1/intelligence_pc/filterCompanyListNR',
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
};
export const getUpcomingCompanyList: (payload: any) => Promise<any> = (payload) => {
  return http({
    url: '/api/v1/intelligence_pc/filterCompanyListUP',
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
};

export const getNoNameFiltersData = (payload: any): Promise<any> => {
  return http({
    url: '/api/v1/intelligence_pc/filterList',
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
};

const fetchRegionsCountriesOfPCGameDetailsStoreRank = (params: any): Promise<any> => {
  return http({
    url: '/api/v1/intelligence_pc/filterPcStoreCountry',
    method: 'post',
    data: params,
    rawData: true,
  }) as Promise<any>;
};

export const fetchRegionsCountriesOfPCGameDetailsStoreRankPlus = async (
  params: any,
): Promise<IRegion[]> => {
  const res = await fetchRegionsCountriesOfPCGameDetailsStoreRank(params);
  return handleRegionsCountriesData2Standard(res?.data);
};

export const getStreamingGamesFiltersData: (payload: any) => Promise<any> = (payload) => {
  return http({
    url: '/api/v1/intelligence_pc/filterCompanyListStreaming',
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
};
export const getStreamingkOLFiltersData: (payload?: any) => Promise<any> = (payload) => {
  return http({
    url: '/api/v1/intelligence_pc/streamingKolFilter',
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
};

export const getDemographicsCountryFilters = (payload: any): Promise<any> => {
  return http({
    url: '/api/v1/intelligence_pc/filterDemoGraphicsCountryList',
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
};

export const getOverlapAnlysisCountryFilters = (payload: any): IBaseResponse<IRegion[]> => {
  return http({
    url: '/api/v1/intelligence_pc/filterCrossAppUsagesCountryList',
    method: 'post',
    data: payload,
    rawData: true,
  }) as IBaseResponse<any>;
};

export const getMobileOverlapAnlysisCountryFilters = (payload: any): IBaseResponse<IRegion[]> => {
  return http({
    url: '/api/v1/intelligence_pc/filterCrossAppUsagesCountryListv2',
    method: 'post',
    data: payload,
    rawData: true,
  }) as IBaseResponse<any>;
};

// 获取SensorTower标签选项
export const getSensorTowerTagFilterList = () => {
  return http({
    url: '/api/v1/intelligence_pc/sensortowerTagFilterList',
    method: 'post',
    data: {},
  }) as Promise<any>;
};
